<template>
    <div :class="classes">


            <svg fill="currentColor" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg"  :class="iconClasses || 'h-5 w-5'"
                xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <rect id="Icons" x="-448" y="-128" width="1280" height="800" style="fill:none;"></rect>
                    <g id="Icons1" serif:id="Icons">
                        <g id="Strike"> </g>
                        <g id="H1"> </g>
                        <g id="H2"> </g>
                        <g id="H3"> </g>
                        <g id="list-ul"> </g>
                        <g id="hamburger-1"> </g>
                        <g id="hamburger-2"> </g>
                        <g id="list-ol"> </g>
                        <g id="list-task"> </g>
                        <g id="trash"> </g>
                        <g id="vertical-menu"> </g>
                        <g id="horizontal-menu"> </g>
                        <g id="sidebar-2"> </g>
                        <g id="Pen"> </g>
                        <g id="Pen1" serif:id="Pen"> </g>
                        <g id="clock"> </g>
                        <g id="external-link"> </g>
                        <g id="hr"> </g>
                        <g id="info"> </g>
                        <g id="warning"> </g>
                        <g id="plus-circle"> </g>
                        <g id="minus-circle"> </g>
                        <path id="caret-left"
                            d="M-45.457,32.027l24.07,-24.07l3.009,3.008l-21.062,21.062l21.062,21.062l-3.009,3.009l-24.07,-24.071Z"
                            style="fill-rule:nonzero;"></path>
                        <g id="vue"> </g>
                        <g id="cog"> </g>
                        <g id="logo"> </g>
                        <path id="connection" d="M32.096,30.055l12,0l-16,25.989l4,-21.989l-12,0l16,-26.016l-4,22.016Z">
                        </path>
                        <g id="radio-check"> </g>
                        <g id="eye-slash"> </g>
                        <g id="eye"> </g>
                        <g id="toggle-off"> </g>
                        <g id="shredder"> </g>
                        <g id="spinner--loading--dots-" serif:id="spinner [loading, dots]"> </g>
                        <g id="react"> </g>
                        <g id="check-selected"> </g>
                        <g id="turn-off"> </g>
                        <g id="code-block"> </g>
                        <g id="user"> </g>
                        <g id="coffee-bean"> </g>
                        <g id="coffee-beans">
                            <g id="coffee-bean1" serif:id="coffee-bean"> </g>
                        </g>
                        <g id="coffee-bean-filled"> </g>
                        <g id="coffee-beans-filled">
                            <g id="coffee-bean2" serif:id="coffee-bean"> </g>
                        </g>
                        <g id="clipboard"> </g>
                        <g id="clipboard-paste"> </g>
                        <g id="clipboard-copy"> </g>
                        <g id="Layer1"> </g>
                    </g>
                </g>
            </svg>



    </div>
</template>

<script>
export default {
    name: "MicIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>